module.exports = __webpack_public_path__ + "static/img/chense.cbde523.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chense.png
// module id = gW+/
// module chunks = 1